import { render, staticRenderFns } from "./BloqueFrases.vue?vue&type=template&id=500a803b&scoped=true"
import script from "./BloqueFrases.vue?vue&type=script&lang=js"
export * from "./BloqueFrases.vue?vue&type=script&lang=js"
import style0 from "./BloqueFrases.vue?vue&type=style&index=0&id=500a803b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a803b",
  null
  
)

export default component.exports